import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';

PouchDB.plugin(PouchDBFind);
export interface SelectedEpiItem {
  _id: string;
  name: string;
  price: number;
  size: string;
}

export interface EpiDoc {
  name: string;
  _id: string;
  price: number;
}

@Injectable({
  providedIn: 'root',
})
export default class EpiService {
  private db = new PouchDB('epis_equipements');
  all(): Observable<EpiDoc[]> {
    const promise = this.db
      .find({
        selector: { type: 'equipement' },
      })
      .then((res) => res.docs as unknown as EpiDoc[]);

    return from(promise);
  }
}
